export function distance(length: number | string | undefined | null): string {
    if (length === undefined || length === null) {
        return '';
    }

    return (`${  length}`).replace('mtrs', 'm');
}
